<template>

    <landing-page-container>

        <landing-page
            v-if="!displayError"
            v-bind="data"
        ></landing-page>

    </landing-page-container>

</template>

<script>

import LandingPage from "@/components/UI/LandingPage/index.vue";
import SimpleError from "@/components/UI/SimpleError.vue";
import RegistrationSurvey from "@/components/UI/LandingPage/RegistrationSurvey.vue";
import LandingPageContainer from "@/components/UI/LandingPage/LandingPageContainer.vue";

export default {

    components: {
        LandingPageContainer,
        LandingPage,
        SimpleError,
        RegistrationSurvey
    },

    data() {
        return {
            data: null,
            displayError: false,
        }
    },

    created() {
        if (window.Spark.error) {
            this.errorMessage = window.Spark.error;
            this.displayError = true;
        } else {
            this.data = Object.assign({}, window.Spark);
        }
    },
}

</script>
